import styled from 'styled-components';

export const Wrapper = styled.div`
  .single-col {
    display: grid;
    grid-template-columns: 1fr;
  }

  .go-back {
    margin: 0 !important;
    position: absolute;
    cursor: pointer;
  }
`;

export const LargeButton = styled.button`
 width: 100%;
 padding: 5px;
 margin-bottom: 9px;
 margin-top: 9px;
`;

export const TextArea = styled.textarea`
 width: 100%;
 padding: 5px;
 margin-bottom: 9px;
`;

export const StyledInput = styled.input`
 padding: 5px;
 margin-left: 19px;
`;

export const Content = styled.div`
  width: 85%;
  margin: 40px auto;
  textarea {
    font-size: 16px;
  }
  outlined {
    border: 2px solid grey;
    background-color: grey;
  }
  interaction-component-container{
    
  }
`;

export const FormLabel = styled.label`
 color: white;
`;

export const ContentRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 3fr;
  margin: 40px 0 65px;
  grid-column-gap: 4%;

  }

  h1 {
    text-align: center;
    font-size: 12px;
    font-weight: 900;
    color: white;
    margin: 0;

    span {
      color: #ff0033;
    }
  }

  h5 {
    color: lightskyblue;
    text-align: center;
    font-size: 16px;
    margin-top: 15px;
  }
`;


// WEBPACK FOOTER //
// ./src/pages/Admin/Lessons/SingleLesson/SingleLesson.styles.ts